import React, { useEffect, useMemo, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Link, useParams } from 'react-router-dom';
import Footer from '../Components/Footer';
import Header from '../Components/Header';

const API = 'https://labwayscientific.com/backend/wp-json/wc/v3';
const CK = 'ck_e1c36267e6a5e3cb0198558262bf2096181b4a0b';
const CS = 'cs_fc900ba31d63fade2cfba415abe8a599366c20b0';

function Shop() {
  const { id } = useParams();

  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [activeCat, setActiveCat] = useState(id || null);
  const [categoryName, setCategoryName] = useState('All Products');
  const [breadcrumb, setBreadcrumb] = useState([]);

  useEffect(() => {
    setActiveCat(id || null);
  }, [id]);

  useEffect(() => {
    fetch(
      `${API}/products/categories?per_page=100&consumer_key=${CK}&consumer_secret=${CS}`
    )
      .then((res) => res.json())
      .then((data) => setCategories(Array.isArray(data) ? data : []))
      .catch(() => setCategories([]));
  }, []);

  useEffect(() => {
    let url = `${API}/products?per_page=24&consumer_key=${CK}&consumer_secret=${CS}`;

    if (activeCat) {
      url += `&category=${activeCat}`;
    }

    fetch(url)
      .then((res) => res.json())
      .then((data) => setProducts(Array.isArray(data) ? data : []))
      .catch(() => setProducts([]));
  }, [activeCat]);

  useEffect(() => {
    if (!activeCat) {
      setCategoryName('All Products');
      return;
    }

    fetch(
      `${API}/products/categories/${activeCat}?consumer_key=${CK}&consumer_secret=${CS}`
    )
      .then((res) => res.json())
      .then((data) => setCategoryName(data?.name || 'All Products'))
      .catch(() => setCategoryName('All Products'));
  }, [activeCat]);

  useEffect(() => {
    if (!activeCat || categories.length === 0) {
      setBreadcrumb([]);
      return;
    }

    const current = categories.find((cat) => cat.id === Number(activeCat));

    if (!current) {
      setBreadcrumb([]);
      return;
    }

    if (current.parent === 0) {
      setBreadcrumb([current]);
      return;
    }

    const parent = categories.find((cat) => cat.id === current.parent);

    if (parent) {
      setBreadcrumb([parent, current]);
    } else {
      setBreadcrumb([current]);
    }
  }, [activeCat, categories]);

  const parentCategories = useMemo(
    () => categories.filter((cat) => cat.parent === 0),
    [categories]
  );

  const getSubCats = (parentId) =>
    categories.filter((cat) => cat.parent === parentId);

  function decodeHTML(html) {
  const txt = document.createElement("textarea");
  txt.innerHTML = html;
  return txt.value;
}

  return (
    <div>
      <Helmet>
        <title>{decodeHTML(categoryName)}</title>
      </Helmet>

      <Header />

      <div className="container main-contant shop-page">
        <div className="inner-page-container shop-page-container">
          <div className="shop-page-heading">
            <div className="shop-breadcrumb">
              <Link to="/">Home</Link>
              <span>&gt;</span>
              {breadcrumb.length === 0 ? (
                <span>All Products</span>
              ) : (
                breadcrumb.map((item, index) => (
                  <React.Fragment key={item.id}>
                    {index > 0 ? <span>&gt;</span> : null}
                    <Link to={`/category/${item.id}`}>{decodeHTML(item.name)}</Link>
                  </React.Fragment>
                ))
              )}
            </div>

            <h1 className="page-title shop-title">{decodeHTML(categoryName)}</h1>
          </div>

          <div className="shop-layout">
            <aside className="shop-sidebar">
              {/* <h3 className="shop-sidebar-title">All Categories</h3> */}

              <div className="shop-sidebar-list">
                <div className="shop-sidebar-section">
                  <Link className="shop-category-link" to="/shop">
                    <button
                      className={`cat-btn ${activeCat === null ? 'active' : ''}`}
                      type="button"
                    >
                      All Products
                    </button>
                  </Link>
                </div>

                {parentCategories.map((parent) => {
                  const subCats = getSubCats(parent.id);
                  const isParentActive = Number(activeCat) === parent.id;
                  const hasActiveSubCat = subCats.some(
                    (sub) => sub.id === Number(activeCat)
                  );

                  return (
                    <div className="shop-sidebar-section" key={parent.id}>
                      <Link
                        className="shop-category-link"
                        to={`/category/${parent.id}`}
                      >
                        <button
                          className={`cat-btn ${
                            isParentActive || hasActiveSubCat ? 'active' : ''
                          }`}
                          type="button"
                        >
                          {decodeHTML(parent.name)}
                        </button>
                      </Link>

                      {subCats.length > 0 ? (
                        <ul className="shop-subcategory-list">
                          {subCats.map((sub) => (
                            <li key={sub.id}>
                              <Link
                                className="shop-category-link"
                                to={`/category/${sub.id}`}
                              >
                                <button
                                  className={`sub-cat-btn ${
                                    Number(activeCat) === sub.id ? 'active' : ''
                                  }`}
                                  type="button"
                                >
                                  {decodeHTML(sub.name)}
                                </button>
                              </Link>
                            </li>
                          ))}
                        </ul>
                      ) : null}
                    </div>
                  );
                })}
              </div>
            </aside>

            <section className="shop-products-area">
              {products.length === 0 ? (
                <div className="shop-empty-state">Product not found!</div>
              ) : (
                <div className="shop-products-grid">
                  {products.map((product) => (
                    <article className="shop-product-card" key={product.id}>
                      <Link
                        className="shop-product-link"
                        to={`/product/${product.id}`}
                      >
                        <div className="shop-product-image-wrap">
                          <img
                            src={product.images[0]?.src}
                            alt={product.name}
                            className="shop-product-image"
                          />
                        </div>

                        <h4 className="shop-product-title">{product.name}</h4>
                      </Link>

                             
                    </article>
                  ))}
                </div>
              )}
            </section>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default Shop;
